import type { ReactNode } from 'react';

import {
	Badge,
	type BadgeTint,
	type BadgeVariant,
} from '@playbook/atoms/badge';

const variants: Record<string, BadgeVariant> = {
	GET: 'success',
	POST: 'information',
	PUT: 'warning',
	PATCH: 'warning',
	DELETE: 'error',
};

interface MethodBadgeProps {
	method: string;
	tint?: BadgeTint;
}

export function MethodBadge({
	method,
	tint = '100',
}: MethodBadgeProps): ReactNode {
	return (
		<Badge variant={variants[method] ?? 'neutral'} tint={tint} label={method} />
	);
}
